import { defineMessages } from 'react-intl';

export enum LineupPosition {
  STARTING_PITCHER = 'Starting pitcher',
  RELIEF_PITCHER = 'Relief pitcher',
  CORNER_INFIELDER = 'Corner infielder',
  MIDDLE_INFIELDER = 'Middle infielder',
  OUTFIELDER = 'Outfielder',
}

export type IndexedPosition =
  | 'Starting pitcher'
  | 'Relief pitcher'
  | 'First base'
  | 'Third base'
  | 'Designated hitter'
  | 'Catcher'
  | 'Second base'
  | 'Shortstop'
  | 'Outfield';

export const MAPPING: Record<IndexedPosition, LineupPosition> = {
  'Starting pitcher': LineupPosition.STARTING_PITCHER,
  'Relief pitcher': LineupPosition.RELIEF_PITCHER,
  'First base': LineupPosition.CORNER_INFIELDER,
  'Third base': LineupPosition.CORNER_INFIELDER,
  'Designated hitter': LineupPosition.CORNER_INFIELDER,
  Catcher: LineupPosition.MIDDLE_INFIELDER,
  'Second base': LineupPosition.MIDDLE_INFIELDER,
  Shortstop: LineupPosition.MIDDLE_INFIELDER,
  Outfield: LineupPosition.OUTFIELDER,
};

export const REVERSE_MAPPING: Record<LineupPosition, IndexedPosition[]> = {
  [LineupPosition.STARTING_PITCHER]: ['Starting pitcher'],
  [LineupPosition.RELIEF_PITCHER]: ['Relief pitcher'],
  [LineupPosition.CORNER_INFIELDER]: [
    'First base',
    'Third base',
    'Designated hitter',
  ],
  [LineupPosition.MIDDLE_INFIELDER]: ['Catcher', 'Second base', 'Shortstop'],
  [LineupPosition.OUTFIELDER]: ['Outfield'],
};

export const positions = [
  LineupPosition.STARTING_PITCHER,
  LineupPosition.RELIEF_PITCHER,
  LineupPosition.CORNER_INFIELDER,
  LineupPosition.MIDDLE_INFIELDER,
  LineupPosition.OUTFIELDER,
];

export const lineupPositionNames = defineMessages<LineupPosition>({
  [LineupPosition.STARTING_PITCHER]: {
    id: 'LineupPosition.starting_pitcher',
    defaultMessage: 'Starting Pitcher',
  },
  [LineupPosition.RELIEF_PITCHER]: {
    id: 'LineupPosition.relief_pitcher',
    defaultMessage: 'Relief Pitcher',
  },
  [LineupPosition.MIDDLE_INFIELDER]: {
    id: 'LineupPosition.middle_infielder',
    defaultMessage: 'Middle infielder',
  },
  [LineupPosition.CORNER_INFIELDER]: {
    id: 'LineupPosition.corner_infielder',
    defaultMessage: 'Corner infielder',
  },
  [LineupPosition.OUTFIELDER]: {
    id: 'LineupPosition.outfield',
    defaultMessage: 'Outfield',
  },
});
